import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { filter, take } from 'rxjs/operators';
import english from '../../../i18n/en.json';
import spanish from '../../../i18n/es.json';
import portuguese from '../../../i18n/pt.json';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent(recurrenceDialogData, fuseTranslationLoaderService, translateService) {
        this.recurrenceDialogData = recurrenceDialogData;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.isUpdate = false;
        this.minDate = moment().startOf('day');
        this.ifDayNotExistsAllMonths = false;
        this.repeatOptions = [
            {
                text: this.translateService.instant('RECURRENCES.INTERVAL.DAILY'),
                value: 'daily',
            },
            {
                text: this.translateService.instant('RECURRENCES.INTERVAL.WEEKLY'),
                value: 'weekly',
            },
            {
                text: this.translateService.instant('RECURRENCES.INTERVAL.MONTHLY'),
                value: 'monthly',
            }
        ];
        this.weekdayOptions = [
            {
                text: this.translateService.instant('RECURRENCES.WEEKDAY.MONDAY'),
                value: 'monday',
            },
            {
                text: this.translateService.instant('RECURRENCES.WEEKDAY.TUESDAY'),
                value: 'tuesday',
            },
            {
                text: this.translateService.instant('RECURRENCES.WEEKDAY.WEDNESDAY'),
                value: 'wednesday',
            },
            {
                text: this.translateService.instant('RECURRENCES.WEEKDAY.THURSDAY'),
                value: 'thursday',
            },
            {
                text: this.translateService.instant('RECURRENCES.WEEKDAY.FRIDAY'),
                value: 'friday',
            },
            {
                text: this.translateService.instant('RECURRENCES.WEEKDAY.SATURDAY'),
                value: 'saturday',
            },
            {
                text: this.translateService.instant('RECURRENCES.WEEKDAY.SUNDAY'),
                value: 'sunday',
            }
        ];
        this.recurrence = this.recurrenceDialogData.recurrence;
        this.isViewMode = this.recurrenceDialogData.isViewMode;
        this.isUpdate = !!this.recurrence && !!this.recurrence.id;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TabGeneralComponent.prototype.skipWeekendChange = function () {
        this.recurrenceForm.get('weekday').setValue('monday');
    };
    TabGeneralComponent.prototype.ngOnInit = function () {
        this.adjustFromDate();
    };
    TabGeneralComponent.prototype.adjustFromDate = function () {
        var _this = this;
        if (!this.recurrenceDialogData.isCopyMode) {
            return;
        }
        var from = moment(this.recurrenceForm.get('from').value);
        if (from.isSameOrAfter(this.minDate)) {
            return;
        }
        this.recurrenceForm.get('from').setValue(this.minDate);
        this.isFromSateAdjusted = true;
        this.recurrenceForm.get('from').valueChanges.pipe(filter(function () { return _this.isFromSateAdjusted; }), take(1)).subscribe(function () {
            _this.isFromSateAdjusted = false;
        });
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
